export default "__VITE_ASSET__BKDGqgnJ__"